// import types from '../actions/types';
// import produce from 'immer';

const initialState = {};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/adsReducer.js